import { useCreateCtx } from '@cleartax/wg-library-hooks';
import { NavigationContext } from './types';

export const [navigationCtx, NavigationProvider] =
  useCreateCtx<NavigationContext>();
